import { EXERCISE_TYPE } from '@gymaholic/packages'
import Text from 'components/Text'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import Collapsible from 'components/Collapsible/index.js'
import { View } from 'components/View.js'

const messages = defineMessages({
  whatTypeOf: {
    id: 'ExerciseContentType.whatTypeOf',
    defaultMessage: 'What type of exercise is the {exerciseName}?'
  },
  whatTypeOfAnswer: {
    id: 'ExerciseContentType.whatTypeOfAnswer',
    defaultMessage: 'It’s a {exerciseType} movement, which makes it an effective exercise {goal}'
  },
  buildMuscle: {
    id: 'ExerciseContentType.buildMuscle',
    defaultMessage: 'if you want to build muscle.'
  },
  getStronger: {
    id: 'ExerciseContentType.getStronger',
    defaultMessage: 'if you want to get stronger.'
  },
  buildStrength: {
    id: 'ExerciseContentType.buildStrength',
    defaultMessage: 'if you want to build strength with technical movements.'
  },
  explosivelyStrong: {
    id: 'ExerciseContentType.explosivelyStrong',
    defaultMessage: 'if your goal is to be explosively strong.'
  },
  loseWeight: {
    id: 'ExerciseContentType.loseWeight',
    defaultMessage: 'if you want to build endurance or lose weight.'
  },
  increaseStamina: {
    id: 'ExerciseContentType.increaseStamina',
    defaultMessage: 'if you want to increase stamina and endurance.'
  },
  improvePosture: {
    id: 'ExerciseContentType.improvePosture',
    defaultMessage: 'if you want to be more flexible and improve your posture.'
  },
  increaseBalance: {
    id: 'ExerciseContentType.increaseBalance',
    defaultMessage: 'if you want to increase your balance, which usually improves your posture and sport performance.'
  },
  releaseMuscleStiffness: {
    id: 'ExerciseContentType.releaseMuscleStiffness',
    defaultMessage: 'to help release muscle stiffness before or after a workout.'
  },
  beforeStartingWorkout: {
    id: 'ExerciseContentType.beforeStartingWorkout',
    defaultMessage: 'to use before starting your workout.'
  },
  buildMobility: {
    id: 'ExerciseContentType.buildMobility',
    defaultMessage: 'if you want to build mobility and get a better posture.'
  }
})

const EXERCISE_TYPE_DESCRIPTION_GOAL = {
  [EXERCISE_TYPE.STRENGTH]: messages.buildMuscle,
  [EXERCISE_TYPE.POWERLIFTING]: messages.getStronger,
  [EXERCISE_TYPE.OLYMPIC_WEIGHTLIFTING]: messages.buildStrength,
  [EXERCISE_TYPE.PLYOMETRIC]: messages.explosivelyStrong,
  [EXERCISE_TYPE.CARDIO]: messages.loseWeight,
  [EXERCISE_TYPE.CONDITIONING]: messages.increaseStamina,
  [EXERCISE_TYPE.STRETCHING]: messages.improvePosture,
  [EXERCISE_TYPE.BALANCE]: messages.increaseBalance,
  [EXERCISE_TYPE.SMR]: messages.releaseMuscleStiffness,
  [EXERCISE_TYPE.WARMUP]: messages.beforeStartingWorkout,
  [EXERCISE_TYPE.YOGA]: messages.buildMobility
}

/**
 * @param {ExerciseContentProps} props
 * @return {Element}
 * @constructor
 */
export default function ExerciseContentType ({
  exerciseType,
  exerciseName,
  type
}) {
  const intl = useIntl()

  const question = (
    formatMessageIntlUtil(
      intl,
      messages.whatTypeOf,
      { exerciseName }
    )
  )

  const goal = formatMessageIntlUtil(
    intl,
    EXERCISE_TYPE_DESCRIPTION_GOAL[type]
  )
  const answer = formatMessageIntlUtil(
    intl,
    messages.whatTypeOfAnswer,
    {
      exerciseType,
      goal
    }
  )

  return (
    <View mt={2}>
      <Collapsible label={question}>
        <Text>
          {answer}
        </Text>
      </Collapsible>
    </View>
  )
}
